import React, { useState } from 'react';

import { StyledSwitch } from './Switch.styled';
import type { SwitchProps } from './Switch.types';

export const Switch = ({ onMouseEnter, onMouseLeave, className = '', ...props }: SwitchProps) => {
  /* 
    By default, MUI uses the `.MuiSwitch-track` class on a nested `span` to control the track color,
    however this `.MuiSwitch-track` span cannot effectively be hovered by a mouse, and so the `:hover`
    css selector does not work as you would expect when combined with the rest of our styles.
    To get around this, we have to manually track the hover state of the root switch.
  */
  const [hovered, setHovered] = useState(false);

  const handleMouseEnter = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    onMouseEnter?.(event);
    setHovered(true);
  };

  const handleMouseLeave = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    onMouseLeave?.(event);
    setHovered(false);
  };

  return (
    <StyledSwitch
      {...props}
      className={hovered ? `hovered-switch ${className}` : className}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    />
  );
};
